import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import { Link } from "gatsby";
import * as Widget from "./Widget";
import ActionCreator from "../ActionCreator";
import Selectors from "../Selectors";
import * as Theme from "../Theme";
import * as Cart from "../Contexts/CartContext";
import Menu from "./Navbar.Menu";
import ProfileNavbar from "./ProfileNavbar";
import { Context } from "../AppContext";
import useAuth from "../hooks/use-auth";

const COLLAPSE_OPTIONS = {
  menu: 0,
  categories: 1,
};

const items = [
  {
    label: "線上訂購",
    subLabel: "SHOP",
    url: "/products",
  },
  { label: "印刷諮詢", subLabel: "QUOTE", url: "/quote" },
  {
    label: "印件分享",
    subLabel: "WORK",
    url: "/works",
  },
  { label: "感官快訊", subLabel: "BLOG", url: "/articles" },
  { label: "常見問題", subLabel: "FAQ", url: "/faq" },
  { label: `關於感官`, subLabel: "INFO", url: "/about" },
];

function Navbar(props) {
  const { cart, appActions, rwdSidebarOpen } = props;
  const [collapsed, setCollapsed] = useState(null);
  const app = React.useContext(Context);
  const { profile } = app.state;
  const profileNavbarRef = useRef(null);
  const { isLogin, handleUnauthenticatedWithLoginModal } = useAuth();

  useEffect(() => {
    const handleClickOutside = (event) => {
      const isMobileProfileInfoClick = event.target.closest(".container");
      if (isMobileProfileInfoClick) {
        return;
      }

      if (
        profileNavbarRef.current &&
        !profileNavbarRef.current.contains(event.target)
      ) {
        appActions.closeRwdSidebar();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [appActions]);

  return (
    <Style.Wrapper>
      <Style.NavBar>
        <Link to="/" className="site-title">
          <img src="/images/logo.svg" alt="logo" height={40} width={53} />
        </Link>
        <Row className="center">
          {items.map((item, idx) => (
            <Link key={idx} to={item.url} className="item">
              {item.label}
            </Link>
          ))}
        </Row>
        <Row>
          <Link
            to="#"
            className="item"
            onClick={(e) => {
              e.preventDefault();
              handleUnauthenticatedWithLoginModal();
            }}
          >
            {!isLogin() ? (
              <div style={{ display: "flex", alignItems: "center" }}>
                <div>登入</div>
              </div>
            ) : (
              <div style={{ display: "flex", alignItems: "center" }}>
                {typeof window !== "undefined" &&
                  window.innerWidth > Theme.breakpoints.xs && (
                    <>
                      <img
                        src="/images/account_filled.svg"
                        alt="profile"
                        width="24"
                        height="auto"
                      />
                    </>
                  )}
              </div>
            )}
          </Link>
          {profile &&
            typeof window !== "undefined" &&
            window.innerWidth <= Theme.breakpoints.xs && (
              <img
                ref={profileNavbarRef}
                src="/images/account_filled.svg"
                alt="profile"
                width="24"
                height="auto"
                onClick={() => {
                  appActions.toggleRwdSidebar();
                }}
              />
            )}
          <Link
            to="#"
            className="item"
            style={{ display: "flex", alignItems: "center" }}
            onClick={(e) => {
              e.preventDefault();
              handleUnauthenticatedWithLoginModal("/cart");
            }}
          >
            <div style={{ position: "relative" }}>
              <img
                src="/images/shopping_cart_outlined.svg"
                alt="shopping cart"
                width="24"
                height="auto"
              />
              {isLogin() && cart.data && cart.data.items.length > 0 && (
                <div
                  style={{
                    position: "absolute",
                    width: 4,
                    height: 4,
                    top: 0,
                    right: 0,
                    backgroundColor: "red",
                    borderRadius: "50%",
                  }}
                />
              )}
            </div>
          </Link>
        </Row>
        {collapsed === COLLAPSE_OPTIONS.menu ? (
          <div className="item-menu" onClick={() => setCollapsed(null)}>
            <img src="/images/close.png" alt="" width="100%" height="auto" />
          </div>
        ) : (
          <div
            className="item-menu"
            onClick={() => setCollapsed(COLLAPSE_OPTIONS.menu)}
          >
            <img src="/images/menu.svg" alt="menu" width="24px" height="auto" />
          </div>
        )}
      </Style.NavBar>
      <Menu
        items={items}
        show={collapsed === COLLAPSE_OPTIONS.menu}
        onClose={() => setCollapsed(null)}
      />
      <ProfileNavbarWrapper rwdSidebarOpen={rwdSidebarOpen}>
        <div className="profile-sidebar">
          <ProfileNavbar />
        </div>
      </ProfileNavbarWrapper>
    </Style.Wrapper>
  );
}

const Style = {
  Wrapper: styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: ${Theme.navbarHeight}px;
    z-index: 15;
    background: white;
    box-shadow: 0px 2px 8px -4px #555;

    @media screen and (max-width: ${Theme.breakpoints.lg}px) {
      //pad
      height: ${Theme.navbarHeightMore}px;
    }
  `,

  NavBar: styled.div`
    display: flex;
    width: 100%;
    gap: 5px;
    align-items: center;
    margin: 0 auto;
    height: 100%;
    padding: 0px 24px;

    @media screen and (max-width: ${Theme.breakpoints.xs}px) {
      padding: 12px 24px;
    }

    & > .center {
      flex: 1;
      justify-content: center;
      & > .item {
        margin-left: 20px;
      }

      @media screen and (max-width: ${Theme.breakpoints.lg}px) {
        & > * {
          display: none;
        }
      }
    }

    & > .item-menu {
      width: 24px;
      display: none;

      @media screen and (max-width: ${Theme.breakpoints.xs}px) {
        width: 24px;
        padding: 2px;
      }

      @media screen and (max-width: ${Theme.breakpoints.lg}px) {
        display: block;
      }
    }
  `,
};

const Row = styled.div`
  display: flex;
  align-items: center;

  & > .item {
    padding: 4px;
    margin-left: 5px;
    cursor: pointer;
    position: relative;
    &:hover {
      opacity: 0.5;
    }
  }

  & > .menu {
    width: 60px;
    text-align: right;
    @media screen and (max-width: ${Theme.breakpoints.xs}px) {
      padding-right: 0px;
      text-align: left;
      width: 30px;
    }
  }
`;

const ProfileNavbarWrapper = styled.div`
  display: none;

  @media screen and (max-width: ${Theme.breakpoints.xs}px) {
    display: block;
    position: relative;
    z-index: -200;
    & > .profile-sidebar {
      display: flex;
      flex-direction: column;
      position: fixed;
      height: auto;
      width: 298px;
      top: ${Theme.navbarHeightMore}px;
      left: ${(props) => (props.rwdSidebarOpen ? "0px" : "-298px")};
      bottom: 0;
      background-color: ${Theme.colors.eggShell};
      overflow-y: auto;
      transition: left 200ms ease-in-out;
      z-index: 200;
    }
  }
`;

export default connect(
  (state, ownProps) => ({
    rwdSidebarOpen: Selectors.getRwdSidebarOpen(state),
  }),
  ActionCreator
)(Cart.withConsumer(Navbar));
